import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import IngredientsTab from '../components/recipes/IngredientsTab';
import RecipesTab from '../components/recipes/RecipesTab';
import PricingTab from '../components/recipes/PricingTab';

export default function AdminRecipes() {
  const [tab, setTab] = useState('ingredients');

  return (
    <div data-testid="admin-recipes-page">
      <div className="mb-5">
        <h2 className="text-xl sm:text-2xl tracking-tight font-semibold text-[#1A2421]">Recipe Costing</h2>
        <p className="text-sm text-[#5C6B64] mt-1">
          Master ingredient list · Recipe builder with yield-adjusted cost per portion · Menu pricing
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="recipes-tabs">
          <TabsTrigger value="ingredients" data-testid="tab-ingredients">Ingredients</TabsTrigger>
          <TabsTrigger value="recipes" data-testid="tab-recipes">Recipes</TabsTrigger>
          <TabsTrigger value="sub-recipes" data-testid="tab-sub-recipes">Sub-Recipes</TabsTrigger>
          <TabsTrigger value="pricing" data-testid="tab-pricing">Pricing</TabsTrigger>
        </TabsList>

        <TabsContent value="ingredients"><IngredientsTab /></TabsContent>
        <TabsContent value="recipes"><RecipesTab mode="top" /></TabsContent>
        <TabsContent value="sub-recipes"><RecipesTab mode="sub" /></TabsContent>
        <TabsContent value="pricing"><PricingTab isActive={tab === 'pricing'} /></TabsContent>
      </Tabs>
    </div>
  );
}
